import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Input } from 'reactstrap'

import './inlineEditor.css'

const InlineEditor = ({ title, onEdit, icon, saveIcon, className }) => {
    const inputRef = useRef(null)

    const [isEditing, setIsEditing] = useState(false)
    const [isHover, setIsHover] = useState(false)
    const [editedTitle, setEditedTitle] = useState(title)

    useEffect(() => {
        setEditedTitle(title)
    }, [title])

    const toggleEditing = () => setIsEditing(!isEditing)

    const handleEditing = () => {
        toggleEditing()
        setTimeout(() => {
            inputRef.current.focus()
        }, 100)
    }
    const handleChangeInput = (e) => {
        e.preventDefault()
        const value = e.target.value
        setEditedTitle(value)
    }

    const handleSave = () => {
        onEdit(editedTitle)
        setIsEditing(false)
    }
    const normalRender = <p className={className}>{title}</p>
    const hoverRender = (
        <React.Fragment>
            <p className={className}>{title}</p>
            <i className={'material-icons'} onClick={handleEditing}>
                {icon}
            </i>
        </React.Fragment>
    )
    const editingRender = (
        <React.Fragment>
            <Input
                value={editedTitle}
                innerRef={inputRef}
                onChange={handleChangeInput}
                onBlur={() =>
                    setTimeout(() => {
                        setIsEditing(false)
                    }, 500)
                }
            />
            <i className={'material-icons'} onClick={handleSave}>
                {saveIcon}
            </i>
        </React.Fragment>
    )

    if (isEditing)
        return (
            <div
                className="edit-inline-wrapper is-editing"
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
            >
                {editingRender}
            </div>
        )
    if (isHover)
        return (
            <div
                className="edit-inline-wrapper is-hover"
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
            >
                {hoverRender}
            </div>
        )
    return (
        <div
            className="edit-inline-wrapper"
            onMouseEnter={() => setIsHover(true)}
            onMouseLeave={() => setIsHover(false)}
        >
            {normalRender}
        </div>
    )
}

InlineEditor.propTypes = {
    title: PropTypes.string,
    onEdit: PropTypes.func.isRequired,
    icon: PropTypes.string,
    saveIcon: PropTypes.string,
}

InlineEditor.defaultProps = {
    title: 'بدون نام',
    icon: 'edit',
    saveIcon: 'save',
}

export default InlineEditor
